<template lang="html">
  <div class="chart-container">
    <canvas id="myChart"></canvas>
  </div>
</template>
<script>
import { Chart } from 'chart.js/auto'

export default {
  name: 'MarketReturns',
  mounted() {
    const ctx = document.getElementById('myChart').getContext('2d')
    new Chart(ctx, {
      type: 'bar',
      data: {
        labels: ['January', 'February', 'March', 'April', 'May', 'June'],
        datasets: [{
          label: 'Market Returns',
          data: [5656, 890, 2343, 3433, 4333, 333],
          backgroundColor: 'rgba(75, 192, 192, 0.2)',
          borderColor: 'rgba(75, 192, 192, 1)',
          borderWidth: 1
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false
      }
    })
  }
}
</script>
<style scoped>
.chart-container {
  width: 100%;
  height: 50vh; /* 👈 Increase this value to make it taller */
}

canvas {
  width: 100% !important;   /* maintain responsiveness */
  height: 100% !important;  /* fill the container height */
}
</style>